"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { useWaveData } from "@/hooks/useWaveData";
import useCapacitor from "@/hooks/useCapacitor";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator, { DropMode } from "@/components/waves/PrivilegedDropCreator";
interface BrainContentInputProps {
  readonly activeDrop: ActiveDropState | null;
  readonly onCancelReplyQuote: () => void;
}
const BrainContentInput: React.FC<BrainContentInputProps> = t0 => {
  const $ = _c(12);
  const {
    activeDrop,
    onCancelReplyQuote
  } = t0;
  const capacitor = useCapacitor();
  const t1 = activeDrop?.drop.wave?.id ?? null;
  let t2;
  if ($[0] !== onCancelReplyQuote) {
    t2 = () => onCancelReplyQuote();
    $[0] = onCancelReplyQuote;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      waveId: t1,
      onWaveNotFound: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: wave
  } = useWaveData(t3);
  const containerClassName = capacitor.isCapacitor ? "tw-max-h-[calc(100vh-14.7rem)]" : "tw-max-h-[calc(100vh-20rem)] lg:tw-max-h-[calc(100vh-20rem)]";
  if (!wave) {
    return null;
  }
  const t4 = `${containerClassName} tw-w-full tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-transition-colors tw-duration-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 tw-sticky tw-top-0 tw-z-30 tw-flex-none tw-rounded-xl tw-bg-iron-950 tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-p-2 md:tw-p-4 tw-shadow-lg`;
  let t5;
  if ($[5] !== activeDrop || $[6] !== onCancelReplyQuote || $[7] !== wave) {
    t5 = <PrivilegedDropCreator wave={wave} activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onAllDropsAdded={onCancelReplyQuote} onDropAddedToQueue={onCancelReplyQuote} key={wave.id} dropId={null} fixedDropMode={DropMode.BOTH} />;
    $[5] = activeDrop;
    $[6] = onCancelReplyQuote;
    $[7] = wave;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default BrainContentInput;